import React from 'react';
import SvgIcon from './SvgIcon';

const MaleUser = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M19.088 20.738a4.573 4.573 0 00-1.613-.638c-3.037-.563-3.037-1.538-3.037-2.138v-.375a5.55 5.55 0 001.575-2.662c.937 0 1.125-1.913 1.125-2.213 0-.3.037-1.425-.9-1.425C18.263 5.813 12.9 3.6 8.888 6.412c-1.65 0-1.8 2.438-1.163 4.875-.937 0-.9 1.163-.9 1.425 0 .263.225 2.213 1.125 2.213a5.55 5.55 0 001.613 2.7V18c0 .6 0 1.575-3.038 2.137a4.462 4.462 0 00-1.612.6"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

MaleUser.displayName = 'MaleUserIcon';

export default MaleUser;
